import React from 'react';
import PatientForm from './components/patient_form';
import Sidebar from '../Sidebar';

const AddPatient = () => {
    
    return (
        <React.Fragment>
            <Sidebar showAppointments={false} />
            {/* <Header /> */}
            <div className='container'>
                <h2>Add Patients</h2>
                
                <div className='card'>
                    <PatientForm type="New" />
                </div>
            </div>
        </React.Fragment>
    );
}

export default AddPatient;
